import { Box, Flex, IconFont, pointer, Text } from '@byecode/ui'
import type { InteractionStyleType } from '@lighthouse/core'
import React from 'react'
import styled, { css } from 'styled-components'

interface TagIconProps extends React.InputHTMLAttributes<HTMLDivElement> {
    icon?: string
    iconSize?: number
    iconColor?: string
    size?: number
    label?: string | React.ReactNode
    className?: string
    radius?: number
    color?: string
    enableHover?: boolean
    hoverColor?: string
    hoverBackground?: string
    background?: string
    isActive?: boolean
    style?: React.CSSProperties
    onClick?: React.MouseEventHandler
}

const SCxIconWrapper = styled.div<{
    size?: number
    radius?: number
    background?: string
    enableHover?: boolean
    hoverColor?: string
    hoverBackground?: string
    isActive?: boolean
    hoverStyle?: React.CSSProperties
    activeStyle?: React.CSSProperties
    disabledStyle?: React.CSSProperties
}>`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${({ size }) => size ?? 16}px;
    height: ${({ size }) => size ?? 16}px;
    border-radius: ${({ radius }) => radius}px;
    color: ${({ color }) => color};
    background: ${({ background }) => background};

    /* ${pointer} */

    ${({ hoverStyle }) =>
        hoverStyle &&
        css`
            &:hover {
                ${Object.entries(hoverStyle)
                    .map(([key, value]) => `${key}: ${value};`)
                    .join('\n')}
            }
        `}
    ${({ activeStyle }) =>
        activeStyle &&
        css`
            &:focus {
                ${Object.entries(activeStyle)
                    .map(([key, value]) => `${key}: ${value};`)
                    .join('\n')}
            }
        `}

    ${({ disabledStyle }) =>
        disabledStyle &&
        css`
            &:disabled {
                ${Object.entries(disabledStyle)
                    .map(([key, value]) => `${key}: ${value};`)
                    .join('\n')}
            }
        `}


    ${({ enableHover, hoverColor, hoverBackground }) =>
        enableHover &&
        css`
            &:hover {
                cursor: pointer;
                color: ${hoverColor};
                background-color: ${hoverBackground};
            }
        `}

    ${({ isActive, hoverColor, hoverBackground }) =>
        isActive &&
        css`
            color: ${hoverColor};
            background-color: ${hoverBackground ?? 'var(--color-gray-100)'};
        `}
`

export const TagIcon = React.forwardRef<HTMLDivElement, TagIconProps>(
    ({ iconSize = 16, radius, label, icon, size, color, iconColor, background, className, children, enableHover, ...rest }, ref) => {
        return (
            <SCxIconWrapper
                ref={ref}
                className={className}
                size={size}
                radius={radius}
                color={iconColor}
                background={background}
                enableHover={enableHover}
                {...rest}
            >
                {children}
                <Text color={color}>{label}</Text>
                {icon && (
                    <Flex data-field-icon alignItems="center">
                        <IconFont size={iconSize} type={icon} />
                    </Flex>
                )}
            </SCxIconWrapper>
        )
    }
)
